<div class="sidebar-chat-container">
  <div class="session-dropdown">
    <button class="session-button" (click)="toggleSessions()">
      <span class="session-label">{{ currentSessionName || 'Nov 22 Summary' }}</span>
      <span class="material-icons">expand_more</span>
    </button>
    @if (showSessions) {
      <div class="session-dropdown-menu">
        @for (session of chatSessions; track session.id) {
          <button class="dropdown-item" [class.active]="currentSessionId === session.id" (click)="loadSession(session)">
            <div class="session-info">
              <span class="session-title">{{ session.title }}</span>
              <span class="session-time">{{ session.timestamp | date:'short' }}</span>
            </div>
            <button class="delete-button" (click)="deleteSession(session, $event)" title="Delete">
              <span class="material-icons">close</span>
            </button>
          </button>
        }
        @if (chatSessions.length > 0) {
          <div class="dropdown-divider"></div>
        }
        <button class="dropdown-item new-session" (click)="startNewSessionFromDropdown()">
          <span class="material-icons">add</span>
          <span>New Chat</span>
        </button>
      </div>
    }
  </div>

  <div class="sidebar-chat-messages">
    @for (message of chatMessages; track $index) {
      <div class="chat-message ai-message">
        <div class="message-bubble">
          {{ message }}
        </div>
      </div>
    }
    @if (isTyping) {
      <div class="chat-message ai-message">
        <div class="message-bubble typing-bubble">
          <span class="typing-indicator">
            <span></span><span></span><span></span>
          </span>
        </div>
      </div>
    }
  </div>

  <div class="sidebar-chat-input-wrapper">
    <form [formGroup]="chatForm" (ngSubmit)="sendMessage()" class="chat-form">
      <div class="chat-input-group">
        <input
          #messageInput
          type="text"
          formControlName="message"
          class="chat-input"
          placeholder="How can we improve?"
          (keydown)="onMessageInputKeydown($event)"
          [disabled]="isRespondingFromLLM" />
        <button
          type="submit"
          class="send-button"
          [disabled]="chatForm.invalid || isRespondingFromLLM"
          (click)="sendMessage()">
          <span class="material-icons">send</span>
        </button>
      </div>
    </form>
  </div>
</div>
